/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const PLT_LOGO = require("./res/images/vLogo.png");
export const DUMMY_IMAGE = require("./res/images/300-300.png");
export const ORDINARY_DAY_IMAGE = require("./res/images/ordinary-day.png");
export const VLINDER_IMAGE = require("./res/images/vlinder-logo.png");
export const SignInUser_Image = require("./res/images/signin-user.png");
export const SignUpUser_Image = require("./res/images/signup-user.png");
export const EyeOpen_Image = require("./res/images/eye_open.png");
export const EyeClose_Image = require("./res/images/eye_close.png");
export const VPFLOGO_Image = require("./res/images/vpf_logo.png");
export const User_Image = require("./res/images/user-1.png");
export const NewPCC_Image = require("./res/images/image11.png");
export const Status_Image = require("./res/images/image21.png");
export const Acknow_Image = require("./res/images/submitted.png");
export const Download_Image = require("./res/images/image31.png");
export const VPF_LOGO_1 = require("./res/images/VPF_LOGO_1.png");

export const IMAGES = [
    PLT_LOGO,
    DUMMY_IMAGE,
    ORDINARY_DAY_IMAGE,
    VLINDER_IMAGE,
    SignInUser_Image,
    SignUpUser_Image,
    EyeOpen_Image,
    EyeClose_Image,
    VPFLOGO_Image,
    User_Image,
    NewPCC_Image,
    Status_Image,
    Download_Image,
    Acknow_Image
];
